export default function toLower (x) {
  return x.toLowerCase()
}
